<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="3"></ucMenu>
					<div class="right_con">
						<div class="goods_main" >
							<p class="fb">售后管理</p>
							<div class="select_wrap">
								<el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">店铺名</p>
									<el-option v-for="item in arrShop" :key="item.key" :label="item.key" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.after_sale_type" @change="changeStatus" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">售后类型</p>
									<el-option v-for="item in arrAfterSalesType" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.type" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">退款/仓库类型</p>
									<el-option v-for="item in typeList" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.after_sale_status" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">售后状态</p>
									<el-option v-for="item in arrStatus" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.apply_reason" placeholder="请选择" clearable filterable>
									<p slot="prefix" class="label_title">申请原因</p>
									<el-option v-for="item in arrApplyReason" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
								<!-- <el-select class="w290" v-model="searchData.after_sale_type" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">售后类型</p>
									<el-option v-for="item in arrAfterSalesType" :key="item.val" :label="item.text" :value="item.val">
									</el-option>
								</el-select> -->
								<el-input class="w290" v-model="searchData.goods_id" placeholder="请输入商品ID" clearable>
									<p slot="prefix" class="label_title">商品ID</p>
								</el-input>
								<el-input class=" w290" v-model="searchData.aftersale_id" placeholder="请输入售后编号" clearable>
									<p slot="prefix" class="label_title">售后编号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.order_no" placeholder="请输入订单编号" clearable>
									<p slot="prefix" class="label_title">订单编号</p>
								</el-input>
								<el-input class="w290" v-model="searchData.express_no" placeholder="请输入物流单号" clearable>
									<p slot="prefix" class="label_title">物流单号</p>
								</el-input>
								<!-- <el-input class=" w290" v-model="searchData.buyer_name" placeholder="请输入收货人姓名" clearable>
									<p slot="prefix" class="label_title">收货人</p>
								</el-input>
								<el-input class="w290" v-model="searchData.buyer_phone" placeholder="请输入收货人手机号" clearable>
									<p slot="prefix" class="label_title">手机号码</p>
								</el-input>-->
								<el-date-picker class="w290"
									v-model="searchData.search_date"
									type="datetimerange"
									align="right"
									unlink-panels
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									value-format="yyyy-MM-dd HH:mm:ss"
									:picker-options="pickerOptions"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
								<el-select class="w290" v-model="searchData.in_deadline" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">临期待处理</p>
									<el-option :value="1" label="是"></el-option>
									<el-option :value="2" label="否"></el-option>
								</el-select>
								<el-select class="w290" v-model="searchData.diff_deal_state" placeholder="请选择" clearable>
									<p slot="prefix" class="label_title">处理不一致</p>
									<el-option :value="0" label="全部"></el-option>
									<el-option :value="10" label="1688同意/抖店拒绝"></el-option>
									<el-option :value="20" label="1688拒绝/抖店同意"></el-option>
									<el-option :value="30" label="处理一致"></el-option>
								</el-select>

								<el-button plain size="small" @click="getList()">查询</el-button>
								<el-button plain size="small" @click="resetSearch()">重置</el-button>
							</div>
							<div class="tabs_wrap">
								<p
									class="tab"
									:class="{ active: searchData.tab_value == s.val, 'tab--has-count': tabBadgeCount(s) > 0 }"
									v-for="(s, i) in arrTabList"
									:key="i"
									@click="onTabChange(s.val)">
									<span class="tab-label">{{ s.text }}</span>
									<el-badge
										v-if="tabBadgeCount(s) > 0"
										class="tab-count-badge"
										:value="tabBadgeCount(s)"
										:max="99"
									/>
								</p>
							</div>
							<div class="totals_btn">
								<p class="totals">共{{page_data.total}}条</p>
								<el-button plain size="small" :loading="batchOperateSubmitting" @click="bindBatchAftersaleOperate(DD_AFTERSALE_BATCH_HANDLE_REFUND)">批量同意退款</el-button>
								<el-button plain size="small" :loading="batchOperateSubmitting" @click="bindBatchAftersaleOperate(DD_AFTERSALE_BATCH_HANDLE_RETURN)">批量同意退货</el-button>
							</div>
							
							<div class="list_title">
								<label class="checkall">
									<el-checkbox v-model="checkAll" :indeterminate="checkListIndeterminate" @change="bindCheckAll">全选</el-checkbox>
								</label>
								<p class="t1">货品信息</p>
								<p class="t2">金额</p>
								<p class="t3">件数</p>
								<p class="t4">售后状态</p>
								<p class="t5">原因</p>
								<p class="t6">操作</p>
							</div>
							<ul class="order_list">
								<el-checkbox-group v-if="list.length" v-model="checkList" @change="bindCheckList">
									<li v-for="(item,index) in list" :key="item.id != null ? item.id : index">
										<div class="info_top">
											<div class="order_nums">
												<div class="check_box">
													<el-checkbox :label="item.id" />
												</div>
												<p class="num" v-if="item.dd_shop">
													<span class="shop_name">{{  isHideOrderInfo ? '************' : item.dd_shop.shop_name }}</span>
													抖店单号：{{ item.sku_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.sku_order_id)"></i>
												</p>
												<p class="num">售后编号：{{ item.aftersale_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.aftersale_id)"></i>
												</p>
												<p class="num" v-if="!item.dd_shop"><span class="shop_name">店铺已删除</span>：{{ item.shop_order_id }}<i class="iconfont icon-fuzhi" @click="bindCopy(item.shop_order_id)"></i></p>
							
												<p class="date">申请时间：{{ item.apply_time }}</p>
											</div>
											<div class="order_flag">
												<el-tag style="margin-left: 5px;" type="primary" size="small">{{ item.text_part.aftersale_type_text }}</el-tag>
											</div>
										</div>
							
							
										<div class="order_info">
											<div class="order_product">
												<div class="product_item">
													<div class="goods_info">
														<div class="img_box"><img class="coverimg" :src="item.order_product.product_pic" @click="openImg(item.order_product)"/></div>
														<div class="con_box">
															<p class="title">{{  isHideOrderInfo ? '************' : item.order_product.product_name }}</p>
															<p class="t1">{{ item.order_product.spec_value }} x {{ item.order_product.item_num }}</p>
															

														</div>
													</div>
													<div class="goods_num">
														<p class="t1">退款金额：<span>{{ item.refund_amount }}</span></p>
														<p class="t2">订单应付：{{ item.order_product.pay_amount }}</p>
														
													</div>
													<div class="goods_sales">
														<p class="t2">x{{ item.aftersale_num }}</p>
													</div>
												</div>
											</div>
											<div class="goods_pay">
												<!-- <div class="t2" v-if="item.pdd_order?.refund_status > 0">采购退款状态：<span>{{ item.pdd_order?.refund_status_text }}</span></div> -->
												<div class="title">{{ item.text_part.aftersale_status_text }}</div>
											</div>
											<div class="goods_buyer">
												<p class="title">{{ item.text_part.reason_text }}</p>
											</div>
											<div class="goods_status">
												<el-link type="text" class="details" @click="goAftersaleDetail(item)">详情</el-link>
											</div>
										</div>
										<div class="info_bottom">
											<p class="t1" v-if="item.order_product.pdd_status>=110">1688售后状态：{{item.order_alibaba_order_refund.refund_status_text}}</p>
											<p class="t1" v-if="item.order_product.pdd_status<110">1688售后状态：未采购</p>
										</div>
									</li>
								</el-checkbox-group>
								<li class="nodata" v-if="page_data.total == 0">暂无数据</li>
							</ul>
							<div class="turn_page">
								<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20,50,100,200,500,1000]" />
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import Pagination from '../../components/pagination/pagination';
import {Loading} from 'element-ui';
import {mapActions} from "vuex";

/** 与接口文档「批量处理抖店售后」一致：单次最多 80 条；handle_type 10 同意退款、20 同意退货 */
const DD_AFTERSALE_BATCH_MAX = 80;
const DD_AFTERSALE_BATCH_HANDLE_REFUND = 10;
const DD_AFTERSALE_BATCH_HANDLE_RETURN = 20;

export default {
	name: "ucenterOrders",
	data() {
		return {
			DD_AFTERSALE_BATCH_HANDLE_REFUND,
			DD_AFTERSALE_BATCH_HANDLE_RETURN,
			order_id: 0,
			options: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			arrAfterSalesType: [],
			arrStatus: [],
			typeList: [],
			arrStar: [],
			arrShop: [],
			arrApplyReason: [],
			arrAfterSales: [],
			arrTabList: [],
			isLoading: false,
			list: [],
			checkAll: false,
			checkList: [],
			isHideOrderInfo: false,
			page_data: {
				limit: 10,
				page: 1,
				total: 0,
			},
			searchData: {
				tab_value: 0
			},
			dialog: {
			
			},
			batchOperateSubmitting: false,
			
		}
	},
	components: {
		myHead, myFoot, ucMenu,Pagination
	},
	computed: {
		checkListIndeterminate() {
			const n = this.list.length
			const c = this.checkList.length
			return n > 0 && c > 0 && c < n
		}
	},
	mounted(){
	
	},
	created() {
		this.getList()
	},
	methods: {
		
		...mapActions({
			getAfterSalesfilterData: "ucenter/getAfterSalesfilterData",
			getOrderAfterSalesList: "ucenter/getOrderAfterSalesList",
			opDdAftersaleBatchOperate: "ucenter/opDdAftersaleBatchOperate",
		}),
		initFilterData() {
			this.getAfterSalesfilterData({
				data: {}, success: (res) => {
					if (res.code === 200) {
						this.arrShop = res.data.arr_shop
						this.arrAfterSalesType = res.data.aftersale_type
						this.typeList = res.data.aftersale_type[0].type_list
						this.arrStatus = res.data.aftersale_type[0].status_list
						this.searchData.after_sale_type = res.data.aftersale_type[0].val
						this.arrTabList = res.data.tab_list
						this.arrApplyReason = Array.isArray(res.data.arr_apply_reason) ? res.data.arr_apply_reason : []
					}
				}
			})
		},
		tabBadgeCount(tabItem) {
			if (!tabItem || tabItem.count_num === undefined || tabItem.count_num === null || tabItem.count_num === '') return 0;
			const n = parseInt(tabItem.count_num, 10);
			return Number.isFinite(n) && n > 0 ? n : 0;
		},
		changeStatus(e) {
			let item = this.arrAfterSalesType.find(item => item.val == e)
			this.typeList = item.type_list
			this.arrStatus = item.status_list
			this.refresh(false)
		},
		onTabChange(e) {
			this.searchData.tab_value = e
			if(e == 100||e == 110){
				this.searchData.after_sale_type = 100;
				this.changeStatus(100);
			}else if(e == 120){
                this.searchData.after_sale_type = 200;
				this.changeStatus(200);
			}else if(e == 130){
				this.searchData.after_sale_type = 300;
				this.changeStatus(300);
			}else{
				this.searchData.after_sale_type = 0;
				this.changeStatus(0);
			}
		},
		openImg(row) {
			console.log(row)
			let htm = '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' + row.product_pic + '" alt="">'
			htm += '<div style="margin-top:10px;font-size:16px;">' + row.spec_value + '</div>';
			htm += '<div style="margin-top:5px;font-size:16px;">实付:￥' + row.pay_amount + '</div>';
			this.$alert(htm, row.product_name, {
				dangerouslyUseHTMLString: true,
				showClose: false,
				confirmButtonText: '关闭',
				closeOnClickModal: true,
				customClass: 'zdy-message-box'
			});
		},
		//重置搜索
		resetSearch() {
			this.searchData = {
				tab_value: ''
			}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		bindCheckAll() {
			const list = this.list
			if (this.checkAll) {
				this.checkList = list.map((row) => row.id).filter((id) => id != null)
			} else {
				this.checkList = []
			}
		},
		bindCheckList() {
			const n = this.list.length
			this.checkAll = n > 0 && this.checkList.length === n
		},
		bindCopy(text) {
			var str = ''
			var input = document.createElement("input"); // 创建input对象
			input.value = text; // 设置复制内容
			document.body.appendChild(input); // 添加临时实例
			input.select(); // 选择实例内容
			document.execCommand("Copy"); // 执行复制
			document.body.removeChild(input); // 删除临时实例
			this.$message({
				message: '复制成功',
				type: 'success'
			});
		
		},
		//刷新列表
		refresh(nowPage = true) {
			if (!nowPage) {
				this.page_data.page = 1
			}
			this.checkAll = false
			this.checkList = []
			this.getList()
		},
		getList(showLoading = true) {
			this.initFilterData();

			if (showLoading) this.isLoading = true
			let loadingInstance = Loading.service({fullscreen: true});

			let param = {limit: this.page_data.limit, page: this.page_data.page}
			param = Object.assign(param, this.searchData)
			this.getOrderAfterSalesList({
				data: param, success: (res) => {
					if (res.code === 200) {
						this.list = res.data.data
						this.page_data.total = res.data.total
						const idSet = new Set(this.list.map((row) => row.id))
						this.checkList = this.checkList.filter((id) => idSet.has(id))
						this.checkAll = this.list.length > 0 && this.checkList.length === this.list.length
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
					this.isLoading = false
					loadingInstance.close()
				}
			})
		},
		goAftersaleDetail(row) {
			if (!row || !row.id) {
				this.$message({ message: '缺少售后记录 ID', type: 'warning' });
				return;
			}
			this.$router.push({ path: '/uc_after_sales_detail', query: { id: String(row.id) } });
		},
		bindBatchAftersaleOperate(handleType) {
			const title =
				handleType === DD_AFTERSALE_BATCH_HANDLE_REFUND ? '批量同意退款' : '批量同意退货';
			if (!this.checkList.length) {
				this.$message({ message: '请先勾选售后', type: 'warning' });
				return;
			}
			if (this.checkList.length > DD_AFTERSALE_BATCH_MAX) {
				this.$message({
					message: `单次最多处理 ${DD_AFTERSALE_BATCH_MAX} 条，请减少勾选数量`,
					type: 'warning',
				});
				return;
			}
			const ids = [...this.checkList];
			this.$confirm(
				`确认对已选的 ${ids.length} 条售后执行「${title}」？系统将逐条刷新并调用抖店接口，单条失败不影响其它条目。`,
				'提示',
				{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
			)
				.then(() => this.submitBatchAftersaleOperate(handleType, ids))
				.catch(() => {});
		},
		submitBatchAftersaleOperate(handleType, ids) {
			this.batchOperateSubmitting = true;
			this.opDdAftersaleBatchOperate({
				data: { handle_type: handleType, ids },
				success: (res) => {
					this.batchOperateSubmitting = false;
					if (res.code !== 200) {
						this.$message({ message: res.msg || '请求失败', type: 'error' });
						return;
					}
					const d = res.data || {};
					const ok = Number(d.success_count) || 0;
					const fail = Number(d.fail_count) || 0;
					const items = Array.isArray(d.items) ? d.items : [];
					const summary = `处理完成：成功 ${ok} 条，失败 ${fail} 条`;
					if (fail > 0 && items.length) {
						const fails = items.filter((x) => x && x.ok !== true);
						const lines = fails
							.slice(0, 30)
							.map((x) => `ID ${x.id}：${x.msg || '失败'}`)
							.join('<br/>');
						const more =
							fails.length > 30
								? `<br/>… 共 ${fails.length} 条失败，仅显示前 30 条`
								: '';
						this.$alert(lines + more, summary, {
							dangerouslyUseHTMLString: true,
							confirmButtonText: '知道了',
							customClass: 'zdy-message-box',
						});
					} else {
						this.$message({
							message: summary,
							type: fail > 0 ? 'warning' : 'success',
						});
					}
					this.checkAll = false;
					this.checkList = [];
					this.getList();
				},
			});
		},
	}
}
</script>

<style lang="less" scoped>
.wrap .wrap_body {
	display: flex;
	flex-direction: column;
}

.center {
	display: flex;
	flex: 1;
}

.ucenter_main {
	padding: 30px 0 40px;
	display: flex;
	justify-content: space-between;
	flex: 1;
}

.right_con {
	width: 980px;
	background: #fff;
}

.goods_main {
	padding: 36px 40px 46px;
	min-height: 70vh;
}

.select_wrap {
	margin-top: 24px;
	display: flex;
	flex-wrap: wrap;
}

.select_wrap .mr {
	margin-right: 15px;
}

.select_wrap .w290 {
	width: 290px;
	margin-top: 14px;
	margin-right: 15px;
}

.select_wrap .w290:nth-child(3n) {
	margin-right: 0;
}

.select_wrap .label_title {
	width: 96px;
	height: 100%;
	font-size: 12px;
	color: #999;
	display: flex;
	align-items: center;
	padding-left: 6px;
}

.select_wrap .label_title .icon-shuoming {
	font-size: 12px;
	color: #999;
	margin-left: 2px;
}

.tabs_wrap {
	margin-top: 20px;
	width: 100%;
	height: 40px;
	border-bottom: 1px solid #eee;
	display: flex;
	// justify-content: space-between;
}

.tabs_wrap .tab {
	height: 100%;
	padding: 0px 14px 0;
	position: relative;
	line-height: 1;
	cursor: pointer;
	font-size: 14px;
	color: #666;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
}

.tabs_wrap .tab.tab--has-count {
	padding-right: 18px;
}

.tabs_wrap .tab .tab-label {
	position: relative;
	z-index: 1;
}

.tabs_wrap .tab .tab-count-badge {
	position: absolute;
	top: 4px;
	right: 2px;
	line-height: 1;
	z-index: 2;
}

.tabs_wrap .tab.active {
	font-weight: bold;
	color: var(--red);
}

.tabs_wrap .tab.active::after {
	content: '';
	width: 100%;
	height: 3px;
	background: var(--red);
	position: absolute;
	left: 0;
	bottom: 0;
	z-index: 2;
}

.tabs_wrap .tab .iconfont {
	font-size: 14px;
	color: #1966ff;
	margin-left: 4px;
}

.totals_btn {
	margin-top: 14px;
	display: flex;
	align-items: center;
}

.totals_btn .totals {
	font-size: 12px;
	color: #333;
	padding-right: 16px;
	margin-right: 16px;
	line-height: 1;
	border-right: 1px solid #ccc;
}

.total_profit {
	margin-left: 10px;
	font-size: 14px;
}

.totals_btn .decrypt_msg {
	font-size: 14px;
	color: var(--red);
	padding-left: 10px;
}

.list_title {
	width: 100%;
	height: 50px;
	background: #f9f9f9;
	margin-top: 10px;
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #666;
	line-height: 1;
}

.list_title .checkall {
	margin-left: 20px;
}

.list_title .t1 {
	margin-left: 10px;
	width: 182px;
}

.list_title .t2 {
	margin: 0 20px;
	width: 120px;
	text-align: left;
}

.list_title .t3 {
	margin: 0 10px;
	width: 60px;
	text-align: left;
}

.list_title .t4 {
	margin-left: 20px;
	width: 140px;
	text-align: left;
}

.list_title .t5 {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.list_title .t6 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.list_title .t7 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.list_title .t8 {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: right;
}

.order_list li {
	margin-top: 10px;
	font-size: 12px;
}

.order_list li .info_top {
	background: #fff6f7;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.order_list li .info_bottom {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-left: 78px;
	padding-top: 10px;
}
.order_list li .info_top .order_flag .flag_box {
	white-space: nowrap;
	padding: 2px 7px;
	color: #fff;
	background: red;
	border-radius: 3px;
	cursor: pointer;
}

.order_list li .info_top .order_flag .flag_box.old {
	background: #0990c0;
}

.order_list li .order_nums {
	width: 100%;
	height: 40px;
	background: #fff6f7;
	display: flex;
	align-items: center;
	position: relative;
}

.order_list li .order_nums .btn-remark {
	position: absolute;
	right: 20px;
	cursor: pointer;
	font-size: 14px;
}

.order_list li .order_nums .check_box {
	margin-left: 20px;
}

.order_list li .order_nums .num {
	display: flex;
	align-items: center;
	margin-left: 12px;
	color: #666666;
}

.order_list li .order_nums .num .iconfont {
	cursor: pointer;
	font-size: 14px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_nums .date {
	margin-left: 26px;
	color: #666666;
}

.order_list li .order_nums .maoli {
	margin-left: 30px;
	color: #666666;
}

.order_list li .order_info {
	padding: 20px 0;
	display: flex;
	align-items: flex-start;
	line-height: 1;
	border-bottom: 1px dashed #eee;

}

.order_list li .order_info .order_product {
	display: flex;
	flex-direction: column;
}

.order_list li .order_info .order_product .product_item {
	display: flex;
	padding-bottom: 20px;
}

.order_list li .order_info .order_product .product_item:last-child {
	padding-bottom: 0;
}

.order_list li .order_info .goods_info {
	width: 242px;
	display: flex;
	margin-left: 20px;
}

.order_list li .order_info .goods_info .img_box {
	width: 48px;
	height: 48px;
	background-color: #eeeeee;
	border-radius: 6px;
	overflow: hidden;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box {
	flex: 1;
	width: 0;
	margin-left: 10px;
}

.order_list li .order_info .goods_info .con_box .title {
	line-height: 16px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.order_list li .order_info .goods_info .con_box .t1 {
	color: #999999;
	margin-top: 12px;
	line-height: 14px;
}

.order_list li .order_info .goods_info .con_box .t2 {
	color: #999999;
	margin-top: 8px;
}

.order_list li .order_info .goods_info .con_box .t2 .sp_remark {
	display: inline-block;
	max-width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	color: #f0b92c;
}

.order_list li .order_info .goods_info .con_box .stock_msg {
	color: var(--red);
	margin-top: 8px;
	display: flex;
	justify-content: space-between;
}

.order_list li .order_info .goods_info .con_box .guanlian {
	color: #1966ff;
	margin-top: 8px;
	cursor: pointer;
}

.order_list li .order_info .goods_info .con_box .guanlian:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_num {
	margin: 0 20px;
	width: 120px;
	text-align: left;
}

.order_list li .order_info .goods_num .t1 {
	color: #333333;
}

.order_list li .order_info .goods_num .t2 {
	color: #999999;
	margin-top: 10px;
}

.order_list li .order_info .goods_sales {
	margin: 0 10px;
	width: 60px;
	text-align: left;
}

.order_list li .order_info .goods_sales > p {
	line-height: 18px;
	color: #333;
}

.order_list li .order_info .goods_sales > p.red {
	color: var(--red);
	cursor: pointer;
}

.order_list li .order_info .goods_pay {
	margin-left: 20px;
	width: 140px;
	text-align: left;
}

.order_list li .order_info .goods_pay .t1 {
	color: #333333;
}

.order_list li .order_info .goods_pay .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_pay .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_pay .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer {
	margin: 0 20px;
	width: 130px;
	text-align: left;
}

.order_list li .order_info .goods_buyer .t1 {
	color: #333333;
}

.order_list li .order_info .goods_buyer .t2 {
	color: #333333;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer .t2 .return_address{
	cursor: pointer;
	color: #666;
}

.order_list li .order_info .goods_buyer .t2 .return_address:hover{
	text-decoration: underline;
}
.order_list li .order_info .goods_buyer .t3 {
	color: #666666;
	margin-top: 20px;
}

.order_list li .order_info .goods_buyer .t4 {
	color: #666666;
	margin-top: 10px;
}

.order_list li .order_info .goods_buyer > p {
	line-height: 18px;
	color: #666;
}

.order_list li .order_info .goods_buyer > p .iconfont {
	cursor: pointer;
	font-size: 12px;
	color: #666;
	margin-left: 8px;
}

.order_list li .order_info .goods_status {
	margin: 0 20px 0 0;
	flex: 1;
	text-align: left;
}

.order_list li .order_info .goods_status:last-child {
	text-align: right;
}

.order_list li .order_info .goods_status > p {
	margin-bottom: 10px;
}

.order_list li .order_info .goods_status .details {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status .details:hover {
	text-decoration: underline;
}

.order_list li .order_info .goods_status p > a {
	color: #f0413e;
	cursor: pointer;
}

.order_list li .order_info .goods_status p > a:hover {
	text-decoration: underline;
}

.order_list li .order_remarks {
	padding: 10px 0;
	border-bottom: 1px solid #eee;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-left: 66px;
}

.order_list li .order_remarks .remarks_item {
	display: flex;
	flex: 1;
}

.order_list li .order_remarks .remarks_item.abnormal {
	width: 100px;
	flex: unset;
	text-align: right;
	color: #f0b92c;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 10px;
	font-weight: bold
}

.order_list li .order_remarks .txt {
	font-size: 12px;
	color: #999999;
	line-height: 18px;
	max-width: 110px;
	box-sizing: border-box;
	padding-left: 10px;
}

.order_list li .order_remarks .remarks {
	flex: 1;
	width: 0;
	font-size: 12px;
	color: #333;
	line-height: 18px;
}

.turn_page {
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
}

.order_list li .order_remarks .remarks i {
	cursor: pointer;
}

.order_list li .check_box {
	margin-left: 20px;
	height: 48px;
	display: flex;
	align-items: center;
}

/deep/ .order_list li .check_box .el-checkbox__label {
	display: none !important;
}

.order_list .shop_name {
	max-width: 120px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: inline-block;
	margin-right: 5px;
}
</style>
<style>
.tabs_wrap .tab .tab-count-badge .el-badge__content {
	border: none;
	background-color: var(--red, #f0413e);
	height: 18px;
	line-height: 18px;
	padding: 0 6px;
	font-size: 12px;
}

.has-time .el-button {
	padding: 7px 15px;
}

.select_wrap .el-button {
	margin-top: 14px;
}

.select_wrap .el-range-editor .el-range-input {
	font-size: 1em;
}

.select_wrap .el-input--prefix .el-input__inner {
	padding-left: 96px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
}

.el-select .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus {
	border-color: var(--red);
}

.el-select-dropdown__item.selected {
	color: var(--red);
}

.select_wrap .el-input--prefix .el-input__inner:focus {
	border-color: var(--red);
}

.el-date-editor .el-range-separator {
	line-height: 26px;
}

.el-date-editor {
	width: 290px !important;
	height: 34px !important;
	line-height: 34px !important;
	font-size: 12px !important;
	margin-top: 14px;
}

.el-range-editor.is-active, .el-range-editor.is-active:hover {
	border-color: var(--red);
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
	background-color: var(--red);
}

.el-date-table td.today span {
	color: var(--red);
}

.el-picker-panel__icon-btn:hover, .el-date-table td span:hover, .el-date-table td div:hover, .el-date-table td.available:hover, .el-picker-panel__shortcut:hover {
	color: var(--red);
}

.el-button {
	color: #333;
	border-color: #ddd;
}

.el-button--small {
	padding: 7px 15px;
}

.el-checkbox {
	color: #666;
	display: flex;
	align-items: center;
}

.el-checkbox__inner {
	border-color: #ddd;
	width: 16px;
	height: 16px;
}

.el-checkbox__input {
	display: flex;
}

.el-checkbox__label {
	font-size: 12px;
	line-height: 1;
}

.el-checkbox__inner::after {
	height: 9px;
	left: 5px;
}

.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
	height: 4px;
}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus {
	border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover {
	color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: var(--red);
}

.el-input__icon {
	line-height: unset;
}

.el-button--primary, .el-button--primary:hover {
	background-color: var(--red) !important;
	border-color: var(--red) !important;
	color: #fff !important;
}

.el-button:hover {
	border-color: var(--red) !important;
	background-color: rgba(240, 65, 62, 0.1) !important;
	color: var(--red) !important;
}

.el-date-editor--datetimerange .el-icon-time {
	line-height: 28px;
}

.el-date-editor .el-range-separator {
	width: 20px;
}
.red{
	color: var(--red) !important;
}
</style>
